import React from 'react';

import MobileMenu from '../MobileMenu/MobileMenu';
import './MobileHeader.css';
import logo from '../Menu/logo.png';
import burger from '../../images/burger.png';

const MobileHeader = ({ onClick, currentItem }) => {
  return (
    <div className="mobile-header">
      <div className="mobile-header-item-wrapper">
        <img src={logo} className="mobile-logo" />
      </div>
      <div className="mobile-header-item-wrapper">{currentItem}</div>
      <div className="mobile-header-item-wrapper">
        <img src={burger} className="burger" />
        <MobileMenu onClickMenu={onClick} />
      </div>
    </div>
  );
};

export default MobileHeader;



// WEBPACK FOOTER //
// ./src/Components/MobileHeader/MobileHeader.js